export var AppsEnum;
(function (AppsEnum) {
    AppsEnum["Giphy"] = "giphy";
})(AppsEnum || (AppsEnum = {}));
//# sourceMappingURL=app.js.map